import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '@/assets/images/Resto_new.png';
const _hoisted_1 = { class: "card bg-success mb-25 border-0 rounded-0 welcome-box" };
const _hoisted_2 = { class: "card-body pe-15 pe-sm-20 pe-md-0 pb-0 pt-15 pt-sm-20" };
const _hoisted_3 = { class: "row align-items-center" };
const _hoisted_4 = { class: "col-lg-6 col-md-6" };
const _hoisted_5 = { class: "title position-relative" };
const _hoisted_6 = { class: "fw-semibold mb-8" };
const _hoisted_7 = { class: "fw-bold" };
const _hoisted_8 = { class: "d-block text-black-emphasis fs-md-15 fs-lg-16" };
const _hoisted_9 = { class: "ps-0 mb-20" };
const _hoisted_10 = { class: "d-inline-block text-uppercase fw-medium fs-13 text-black-emphasis position-relative" };
const _hoisted_11 = { class: "d-block fw-black lh-1 text-black mt-5 mt-md-10" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("h3", _hoisted_6, [
                            _createTextVNode(_toDisplayString(_ctx.$t('dashboard.greeting')) + ", ", 1),
                            _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.fullName) + "!", 1)
                        ]),
                        _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('dashboard.whatHappeningToday')), 1)
                    ]),
                    _createElementVNode("ul", _hoisted_9, [
                        _createElementVNode("li", _hoisted_10, [
                            _createTextVNode(_toDisplayString(_ctx.$t('dashboard.salesThisWeek')) + " ", 1),
                            _createElementVNode("span", _hoisted_11, _toDisplayString(Math.floor(parseFloat(_ctx.orderAmount))) + " CHF ", 1)
                        ])
                    ])
                ]),
                _cache[0] || (_cache[0] = _createElementVNode("div", { class: "col-lg-6 col-md-6 text-center mt-15 mt-md-0" }, [
                    _createElementVNode("img", {
                        src: _imports_0,
                        alt: "welcome-image",
                        style: { "width": "190px", "height": "auto" }
                    })
                ], -1))
            ])
        ])
    ]));
}
